// extracted by mini-css-extract-plugin
export default {"Container":"NewSearch_Container__rezyb","SearchIcon":"NewSearch_SearchIcon__xQSrs"};